import { OverlayModule } from '@angular/cdk/overlay';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  
  imports:[
    MatDialogModule,OverlayModule
  ],
  standalone:true,
  providers: [MatDialogConfig],
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true); // Pass `true` when confirmed
  }

  onCancel(): void {
    this.dialogRef.close(false); // Pass `false` when canceled
  }
}
